import { WithModal } from "../Modal"
import { Button } from "../atoms/Buttons"
import { DownloadableResourceForm } from "./DownloadableResourceForm"
import React, { useCallback } from "react"
import PropTypes from "prop-types"

export const DownloadModal = props => {
  const toggle = useCallback(
    show => (
      <Button
        className="downloadButton"
        buttonStyle={"grey"}
        onClick={() => show()}
      >
        Download
      </Button>
    ),
    []
  )

  const dlContent = useCallback(
    ({ showModal, hideModal }) => (
      <DownloadableResourceForm
        formUrl={props.formUrl}
        fileUrl={props.fileUrl}
        fileName={props.fileName}
        showModal={showModal}
        hideModal={hideModal}
        contentfulId={props.contentfulId}
        incrementDownloads={props.incrementDownloads}
        linkUrl={props.linkUrl}
      />
    ),
    []
  )

  return <WithModal toggle={props.toggle || toggle} ChildContent={dlContent} />
}

DownloadModal.propTypes = {
  formUrl: PropTypes.string.isRequired,
  fileUrl: PropTypes.string.isRequired,
  fileName: PropTypes.string.isRequired,
  incrementDownloads: PropTypes.func,
  contentfulId: PropTypes.string.isRequired,
  linkUrl: PropTypes.string.isRequired,
  toggle: PropTypes.func, // Optional custom toggle function, see default one above for signature
}
